import React from "react";
import "./Footer.css";

const Footer = () => {
    return <footer className="footer">© 2026 Scoldy Social V9.8.0 All rights reserved.</footer>;
};

export default Footer;
